import React from "react";
import { RiFacebookBoxLine } from "react-icons/ri";
import { FaInstagram, FaWhatsapp } from "react-icons/fa6";
import { LiaTwitterSquare } from "react-icons/lia";
import { CiTwitter, CiMail } from "react-icons/ci";
import { MdOutlinePhoneInTalk } from "react-icons/md";
import { PiFacebookLogo, PiInstagramLogoLight } from "react-icons/pi";
import { Link } from "react-router-dom";
import Button from "../Lcomp/Button";

const Footer = () => {
  return (
    <footer className="grid_col_footer_sm md:grid_col_footer_md lg:grid_col_footer gap-12 px-[25px] sm:px-16 py-14 w-full">
      {/* Logo + Socials */}
      <div>
        {/* <img src="/assets/bmt/logo_footer.png" alt="BMT Logo" className="" /> */}
        <div className="flex items-center">
          {/* Footer Logo 1 */}
          <img
            src="./assets/bmt/scfn_logo.PNG"
            alt="BMT Logo"
            className="h-16 w-auto object-contain"
          />

          {/* Divider */}
          <div className="mx-2 h-7 w-[2px] bg-black/50 rounded-full" />

          {/* Footer Logo 2 */}
          <img
            src="./assets/bmt/luth_logo2.PNG"
            alt="SFCN Logo"
            className="h-10 w-auto object-contain"
          />
        </div>
        <div className="flex items-center justify-start text-3xl mt-6 space-x-5">
          {/* Instagram */}
          <Link
            to="https://instagram.com/sicklecellfoundationng?igshid=MzMyNGUyNmU2YQ=="
            target="_blank"
            className="text-[#E4405F] hover:opacity-80 transition"
          >
            <FaInstagram className="cursor-pointer" />
          </Link>

          {/* Facebook */}
          <Link
            to="https://www.facebook.com/sicklecellfoundation?mibextid=ZbWKwL"
            target="_blank"
            className="text-[#1877F2] hover:opacity-80 transition"
          >
            <RiFacebookBoxLine className="cursor-pointer" />
          </Link>

          {/* X (Twitter) */}
          <Link
            to="https://twitter.com/sicklecellnig"
            target="_blank"
            className="text-[#1DA1F2] hover:opacity-80 transition"
          >
            <LiaTwitterSquare className="cursor-pointer" />
          </Link>
        </div>
      </div>

      {/* Platforms */}
      <div className="space-y-3">
        <span className="font-bold">Platforms</span>
        <ul className="flex flex-col w-max space-y-5">
          <Link to="/about">About</Link>
          <Link to="/donation">Donation</Link>
          <Link to="/education">Education & Awareness</Link>
          <Link to="/research">Research & Innovation</Link>
          <Link to="/whattoexpect">Patient Information</Link>
        </ul>
      </div>

      {/* Contact Us */}
      <div className="space-y-3">
        <span className="font-bold">Contact Us</span>
        <ul className="flex flex-col w-max space-y-5">
          {/* Phone */}
          <Link to="tel:+2348135190029" className="flex items-center gap-2">
            <MdOutlinePhoneInTalk className="text-2xl" />
            <span>+234 813 519 0029</span>
          </Link>

          {/* Twitter */}
          <Link
            to="https://twitter.com/sicklecellnig"
            target="_blank"
            className="flex items-center gap-2 transition"
          >
            <CiTwitter className="text-3xl text-[#1DA1F2] hover:text-[#1a8cd8]" />
            <span>@sicklecellnig</span>
          </Link>

          {/* Instagram */}
          <Link
            to="https://instagram.com/sicklecellfoundationng?igshid=MzMyNGUyNmU2YQ=="
            target="_blank"
            className="flex items-center gap-2 transition"
          >
            <PiInstagramLogoLight className="text-3xl text-[#E4405F] hover:opacity-80" />
            <span>@sicklecellfoundationng</span>
          </Link>

          {/* Facebook */}
          <Link
            to="https://www.facebook.com/sicklecellfoundation?mibextid=ZbWKwL"
            target="_blank"
            className="flex items-center gap-2 transition"
          >
            <PiFacebookLogo className="text-3xl text-[#1877F2] hover:opacity-80" />
            <span>@sicklecellfoundation</span>
          </Link>

          {/* Email */}
          <Link
            to="mailto:info@sicklecellfoundation.com"
            target="_blank"
            className="flex items-center gap-2"
          >
            <CiMail className="text-3xl" />
            <span>info@sicklecellfoundation.com</span>
          </Link>

          <Link
            to="https://wa.me/2348108188085"
            target="_blank"
            className="flex items-center gap-2 transition"
          >
            <FaWhatsapp className="text-[#25D366] hover:opacity-80 text-3xl" />{" "}
            <span>+234 810 818 8085</span>
          </Link>

          {/* --- New Section: BMT Hotlines --- */}
          {/* <div className="mt-4 space-y-2">
            <span className="font-semibold">BMT Hotlines:</span>
            <Link to="tel:+2349139576826" className="flex items-center gap-2">
              <MdOutlinePhoneInTalk className="text-xl" />{" "}
              <span>0913 957 6826</span>
            </Link>
            <Link to="tel:+2349139576827" className="flex items-center gap-2">
              <MdOutlinePhoneInTalk className="text-xl" />{" "}
              <span>0913 957 6827</span>
            </Link>
            <Link to="tel:+2349139576828" className="flex items-center gap-2">
              <MdOutlinePhoneInTalk className="text-xl" />{" "}
              <span>0913 957 6828</span>
            </Link>
            <Link
              to="https://wa.me/2348135190029"
              target="_blank"
              className="flex items-center gap-2 text-[#25D366] hover:opacity-80 transition"
            >
              <FaWhatsapp className="text-green-500 text-xl" />{" "}
              <span>+234 813 519 0029</span>
            </Link>
          </div> */}

          {/* --- New Section: BMT Emails --- */}
          <div className="mt-4 space-y-2">
            <span className="font-semibold">BMT Emails:</span>
            <Link
              to="mailto:bmtenquiries@sicklecellfoundation.com"
              className="flex items-center gap-2"
            >
              <CiMail className="text-xl" />{" "}
              <span>bmtenquiries@sicklecellfoundation.com</span>
            </Link>
            <Link
              to="mailto:scfn.luthbmt@gmail.com"
              className="flex items-center gap-2"
            >
              <CiMail className="text-xl" /> <span>scfn.luthbmt@gmail.com</span>
            </Link>
          </div>
        </ul>
      </div>

      {/* Subscribe */}
      <div className="space-y-5">
        <span className="font-bold">Subscribe</span>
        <p>
          Subscribe now for valuable information and stay connected with our
          mission.
        </p>
        <Link to="https://zc.vg/MFcKl" target="_blank">
          <Button
            classes="px-[68px] py-[10px] bg-primary_red font-Lexend font-bold rounded-[4px] hover:bg-primary_red/80 trans_animate block text-white mt-5 text-[15px] w-full"
            text="Subscribe"
          />
        </Link>
      </div>
    </footer>
  );
};

export default Footer;
